<template>
    <div class="tableStyle">
        <div class="buttonStyle">
            <el-button icon="el-icon-circle-plus-outline" type="primary" plain @click="assigningRoles">{{ "分配角色"
                }}</el-button>
            <el-button icon="el-icon-delete" type="danger" plain @click="removeRoles">{{ "移除角色" }}</el-button>
        </div>
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;"
            :header-cell-style="headerCellStyle" @selection-change="handleRolesSelectionChange"
            @cell-click="getPermissionsByTheRole" border stripe max-height="350">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="name" label="角色名称">
            </el-table-column>
            <el-table-column prop="description" label="描述">
            </el-table-column>
            <el-table-column prop="status" label="状态">
            </el-table-column>
        </el-table>
        <div class="flex-container">
            <span>{{ roleName + " — — 关联权限" }}</span>
            <div class="divider"></div>
        </div>
        <div class="buttonStyle">
            <el-button plain @click="authorizeTheRole" icon="el-icon-circle-plus-outline" type="primary"
                :disabled="buttonDisabled">{{ "授权" }}</el-button>
            <el-button plain @click="removePermissions" icon="el-icon-delete" type="danger"
                :disabled="buttonDisabled">{{ "移除权限" }}</el-button>
        </div>
        <el-table ref="multipleTable" :data="permissionTableData" tooltip-effect="dark" style="width: 100%"
            :header-cell-style="headerCellStyle" @selection-change="handlePermissionsSelectionChange" border stripe
            max-height="350">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="name" label="权限名称">
            </el-table-column>
            <el-table-column prop="description" label="描述">
            </el-table-column>
            <el-table-column prop="type" label="类型">
            </el-table-column>
            <el-table-column prop="className" label="分类">
            </el-table-column>
        </el-table>
        <!-- 授权弹出框 -->
        <el-dialog :modal="false" :close-on-click-modal="false" title="添加权限" :visible.sync="grantDialogVisible"
            width="50%">
            <div class="centered-div">
                <el-transfer :render-content="renderFunc" filterable :titles=tableName :button-texts="['', '']"
                    v-model="assignedPrivs" :data="allPrivs"></el-transfer>
            </div>
            <span slot="footer">
                <el-button size="small" round @click="grantDialogVisible = false">{{ "取消" }}</el-button>
                <el-button size="small" round type="primary" icon="el-icon-setting" @click="authority">{{ "授权"
                    }}</el-button>
            </span>
        </el-dialog>
        <!-- 分配角色弹出框 -->
        <el-dialog :modal="false" :close-on-click-modal="false" title="添加角色" :visible.sync="rolesDialogVisible"
            width="50%">
            <div class="centered-div">
                <el-transfer :render-content="renderFunc" filterable :titles=tableName :button-texts="['', '']"
                    v-model="assignedRoles" :data="allRoles"></el-transfer>
            </div>
            <span slot="footer">
                <el-button size="small" @click="rolesDialogVisible = false">{{ "取消" }}</el-button>
                <el-button size="small" type="primary" icon="el-icon-setting" @click="submit">{{ "确定" }}</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
import axios from "axios";
import { get } from "sortablejs";
export default {
    data() {
        return {
            tableData: [],//角色
            permissionTableData: [],//权限
            multipleRolesSelection: [],
            multiplePermissionsSelection: [],
            roleName: "",
            roleId: "",
            allPrivType: [],
            buttonDisabled: true,
            grantDialogVisible: false,
            rolesDialogVisible: false,
            tableName: ['待选项', '已选择'],
            allPrivs: [],
            assignedPrivs: [],
            allRoles: [],
            assignedRoles: [],
            headerCellStyle: {
                backgroundColor: '#F8F8F9',
                color: '#606266'
            }
        }
    },

    created() {
        this.getRolesSelected();
        this.getAllPrivType();
    },

    methods: {
        //获取当前用户已经选择的角色
        getRolesSelected() {
            let obj = {
                ... this.$store.state.objectId,
            };
            axios.get(`/pmdm/admin/user/getRoles${this.params(obj)}`).then(res => {
                if (res.data.code == 200) {
                    let data = res.data.object.roles;
                    this.tableData = data.map((item) => {
                        return { name: item.name, description: item.description, status: item.status == 1 ? "启用" : "禁用", id: item.id };
                    });
                }
            }).catch(error => {
                console.error('请求失败:', error.message || '网络请求出错');
            });
        },
        //根据选中角色获取该角色的权限
        getPermissionsByTheRole(row) {
            this.roleName = row.name;
            this.roleId = row.id;
            let roleId = row.id;
            console.log(this.allPrivType);

            axios.get("/pmdm/admin/role/getPrivs?id=" + roleId).then(res => {
                if (res.data.code == 200) {
                    let data = res.data.object.privs;
                    this.permissionTableData = data.map((item) => {
                        const { id, name, className, description } = item;
                        const type = this.allPrivType.find(i => i.id == item.type)?.name || '';
                        return { id, name, description, type, className }

                    });
                    this.buttonDisabled = false;
                }
            })
                .catch(error => {
                    console.error('请求失败:', error.message || '网络请求出错');
                });
        },
        //获取系统中权限类型id对应的名称
        getAllPrivType() {
            axios.get("pmdm/admin/priv/getAllPrivType").then(res => {
                if (res.data.code == 200) {
                    this.allPrivType = res.data.object.privType;
                }
            }).catch(function (error) {
                console.error('请求失败:', error.message || '网络请求出错');
            });
        },
        //移除当前角色的一个或多个权限
        removePermissions() {
            let a = this.permissionTableData.map(obj => obj.id);
            let b = this.multiplePermissionsSelection.map(obj => obj.id);
            const filteredA = a.filter(item => !b.includes(item));
            if (b.length == 0) {
                this.$message({
                    showClose: true,
                    message: '请至少选择一条权限！',
                    type: 'warning'
                });
                return;
            }
            let data = {
                id: this.roleId + '',
                assignedPrivs: filteredA
            };
            this.$confirm('您确定要移除已选权限吗?').then(_ => {
                axios.post("/pmdm/admin/role/assignPrivs", data).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            showClose: true,
                            message: "移除权限成功！",
                            type: "success",
                        });
                        this.renewPermissionData();
                    }
                }).catch(function (error) {
                    console.error('请求失败:', error.message || '网络请求出错');
                });
            }).catch(_ => { });
        },
        //点击授权按钮后
        authorizeTheRole() {
            const apiList = [
                { func: () => axios.get("/pmdm/admin/priv/getAll") },
                { func: () => axios.get("/pmdm/admin/role/getPrivs?id=" + this.roleId) },
            ];
            const arr = apiList.map(item => item['func'](this.roleId))
            Promise.all(arr).then(res => {
                const [allPrivs, assignedPrivs] = res.map(i => i.data.object.privs);
                this.allPrivs = allPrivs.map(i => ({ key: i.id, label: i.name }));
                this.assignedPrivs = assignedPrivs.map(i => i.id)
            }).finally(() => {
                this.grantDialogVisible = true;
            });
        },
        //授权
        async authority() {
            const { data: res } = await axios.post(
                "/pmdm/admin/role/assignPrivs", {
                id: this.roleId + '',
                assignedPrivs: this.assignedPrivs
            });
            if (res.code == 200) {
                this.$message({
                    showClose: true,
                    message: "授权成功！",
                    type: "success",
                });
                this.renewPermissionData();
            } else {
                this.$message.error(res.message);
            };
            this.grantDialogVisible = false;
        },
        //移除一个或多个角色
        removeRoles() {
            let a = this.tableData.map(obj => obj.id.toString());
            let b = this.multipleRolesSelection.map(obj => obj.id.toString());
            const filteredA = a.filter(item => !b.includes(item));
            if (b.length == 0) {
                this.$message({
                    showClose: true,
                    message: '请至少选择一个角色！',
                    type: 'warning'
                });
                return;
            }
            let data = {
                ... this.$store.state.objectId,
                assignedRoles: filteredA
            };
            this.$confirm('您确定要移除已选角色吗?').then(_ => {
                axios.post("/pmdm/admin/user/assignRoles", data).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            showClose: true,
                            message: "移除权限成功！",
                            type: "success",
                        });
                        this.getRolesSelected();
                        this.permissionTableData = [];
                        this.roleName = "";
                        this.buttonDisabled = true;
                    }
                }).catch(function (error) {
                    console.error('请求失败:', error.message || '网络请求出错');
                });
            }).catch(_ => { });
        },
        //点击分配角色后
        assigningRoles() {
            let obj = {
                ... this.$store.state.objectId
            };
            const apiList = [
                () => axios.get("/pmdm/admin/role/getAll"),
                () => axios.get(`/pmdm/admin/user/getRoles${this.params(obj)}`),
            ].map((func) => func());
            Promise.all(apiList).then(res => {
                const [allRoles, assignedRoles] = res.map((i) => i.data.object.roles);
                this.allRoles = allRoles.map((i) => ({ key: i.id, label: i.name }));
                this.assignedRoles = assignedRoles.map((i) => i.id);
            }).finally(() => {
                this.rolesDialogVisible = true;
            });
        },
        //分配角色
        async submit() {
            const { data: res } = await axios.post(
                "/pmdm/admin/user/assignRoles", {
                ... this.$store.state.objectId,
                assignedRoles: this.assignedRoles.map(obj => obj.toString())
            });
            if (res.code == 200) {
                this.$message({
                    showClose: true,
                    message: "分配角色成功！",
                    type: "success",
                });
                this.getRolesSelected();
            } else {
                this.$message.error(res.message);
            };
            this.rolesDialogVisible = false;
        },
        //更新权限表格数据
        renewPermissionData() {
            let row = {
                name: this.roleName,
                id: this.roleId
            };
            this.getPermissionsByTheRole(row);
        },
        //左侧列表添加鼠标划上显示
        renderFunc(h, option) {
            return <span title={option.label}>{option.label}</span>;
        },

        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleRolesSelectionChange(val) {
            this.multipleRolesSelection = val;
        },
        handlePermissionsSelectionChange(val) {
            this.multiplePermissionsSelection = val;
        }
    }
}
</script>

<style scoped>
.tableStyle {
    margin: 2% 3%;
}

::v-deep.el-table th {
    text-align: center;
}

::v-deep.el-table td {
    text-align: center;
}

.buttonStyle {
    margin: 1% 0;
}

.flex-container {
    padding-top: 1%;
    display: flex;
    align-items: center;
}

.divider {
    flex-grow: 1;
    height: 1px;
    background-color: #000000;
    margin: 0 5px;
}

.el-table__row {
    height: 40px;
    /* 设置你想要的行高 */
    line-height: 40px;
    /* 使文本垂直居中，如果需要的话 */
}

.centered-div {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>